import React from "react";
import { Button, Col, Flex, Layout, Modal, notification, Row, Skeleton, Space } from "antd";
import { mdiAccountCash, mdiAccountGroup, mdiAirplane, mdiBagChecked, mdiBedKing, mdiClose, mdiEmailOutline, mdiFileDownload, mdiFlagTriangle, mdiMapMarker, mdiMapMarkerOutline, mdiMenuDown, mdiMenuLeft, mdiMenuRight, mdiMenuUp, mdiPhoneInTalkOutline, mdiReceiptText, mdiShieldAccount, mdiShieldAirplane, mdiSilverwareForkKnife, mdiWhatsapp } from "@mdi/js";
import Icon from "@mdi/react";
import Headline from "../components/shared/Headline";
import { Content } from "antd/es/layout/layout";
import Sider from "antd/es/layout/Sider";
import SeriesApi from "../../api-services/series-api.service";
import { useParams } from "react-router-dom";
import { Itinerary } from "../../interfaces/itinerary.interface";
import AgentsApi from "../../api-services/agents-api.service";
import { Agent } from "../../interfaces/agent.interface";
import PriceDetails from "../components/PriceDetails";
import ContactAgentsForm from "../components/shared/ContactAgentsForm";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import Slider from "react-slick";

const breadcrumbs = [
  { title: 'Home' },
]


const settings = {
  dots: false,
  arrows: true,
  slidesToShow: 7.5,
  pauseOnHover:false,
  speed: 500,
  infinite: false,
  slidesToScroll: 1,
  prevArrow: <Icon path={mdiMenuLeft} size={2} />,
  nextArrow: <Icon path={mdiMenuRight} size={2} />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5.5,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3.5,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2.5,
        }
      },
    ]
 };

const thingsToKnow = (inclusionsData) => {
  return [
    {icon: <Icon path={mdiShieldAccount} size={1} />, label: "Free Travel Insurance", visible: inclusionsData.acf},
    {icon: <Icon path={mdiReceiptText} size={1} />  , label: "Airport Taxes", visible: inclusionsData.airport_taxes},
    {icon: <Icon path={mdiFlagTriangle} size={1} />, label: "Tour Leader", visible: inclusionsData.tour_leader},
    {icon: <Icon path={mdiBagChecked} size={1} />, label: "Check-in Baggage", visible: inclusionsData.luggage},
    {icon: <Icon path={mdiSilverwareForkKnife} size={1} />, label: "Meal Onboard", visible: inclusionsData.meal_onboard},
    {icon: <Icon path={mdiBedKing} size={1} />, label: "Hotel", visible: inclusionsData.hotel},
    {icon: <Icon path={mdiAccountCash} size={1} />, label: "Gratuities", visible: inclusionsData.gratuities},
    {icon: <Icon path={mdiAccountGroup} size={1} />, label: "Group Departure", visible: inclusionsData.group_departure},
    {icon: <Icon path={mdiFileDownload} size={1} />, label: "Itinerary Download EN | CN"}
  ];
} 

const layoutStyle = {
  overflow: 'hidden',
};

const siderStyle = {
  backgroundColor: 'transparent'
}


function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}

class ShowPage extends React.Component <{params;}> {
  seriesApi = new SeriesApi;
  agentsApi = new AgentsApi;

  state = {
    loading: true,
    itinerary: {includings:{}, tours:[], priceCurrency:"", country: "", description: "", coverImage: ""},
    selectedTour:{id: null,guaranteed_departure:false, flights:[], caption:"", code:"", prices: []},
    setIsModalOpen: false,
    loadingAgents: true,
    allAgents: [],
    agents: [],
    states: [],
    cities: [],
    showAgentsResults: false,
    agentData: { name: "", image: "", address: "", phone: "", whatsapp: "", email: "", city: "", state: "" },
    isCollapsed: true,
    showContactAgent: false
  }


  componentDidMount() {
    this.seriesApi.getItinerary(this.props.params.id)
      .then((itineraryData:Itinerary) => {
        this.setState({itinerary: itineraryData});
        if(itineraryData.tours && itineraryData.tours?.length > 0){
          this.setState({selectedTour: itineraryData.tours[0]});
        } 
      })
    .finally(()=>this.setState({loading: false}))
      .catch(error => {
        notification.error({ message: 'An error occured while loading itinerary.'});
      });

    this.getAgents();
  }


  getAgents(){
    this.agentsApi.getAgents()
      .then((agentsData:Agent[]) => {
        this.setState({agents: agentsData, allAgents: agentsData});
        this.resetAgents(agentsData);
      })
      .finally(()=>this.setState({loading: false}))
      .catch(error => {
        notification.error({ message: 'An error occured while loading agents.'});
      });
  }

  selectTour(tourId:number){
    const selectedTour:any = this.state.itinerary.tours.find((tour:any) => tour.id == tourId);
    if(selectedTour){
      this.setState({selectedTour});
    }
  }

  showModal(agentData){
    this.setState({setIsModalOpen: true, agentData: agentData});
  };

  closeModal(){
    this.setState({setIsModalOpen: false});
  };


  filterCities = (searchStr) => {
    const allAgents:Agent[] = this.state.allAgents;

    if(searchStr == undefined){
      this.resetAgents();
      return;
    }
    const agents:Agent[] = allAgents.filter(a => a.state == searchStr);
    const results = agents.map(a => a.city);
    this.setState({cities: results});
  }


  filterStates= (searchStr) => {
    const allAgents:Agent[] = this.state.allAgents;

    if(searchStr == undefined){
      this.resetAgents();
      return;
    }

    const agents:Agent[] = allAgents.filter(a => a.city == searchStr);
    const results = agents.map(a => a.state);
    this.setState({states: results});
  }

  resetAgents(agents?){
    const allAgents:Agent[] = agents || this.state.allAgents;
    const states = allAgents.filter(a => a.state?.replace(/\s/g, "") != '').map(a => a.state);
    const cities = allAgents.filter(a => a.city?.replace(/\s/g, "") != '').map(a => a.city);
    let uniqStates = [... new Set(states.map(x=>x))];
    let uniqCities = [... new Set(cities.map(x=>x))];
    this.setState({states: uniqStates, cities: uniqCities});
  }

  findAgents = (formValues) => {
    const allAgents:Agent[] = this.state.allAgents;
    const agents = allAgents.filter(a => 
      (formValues.state == undefined || a.state === formValues.state) && 
      (formValues.city == undefined || a.city === formValues.city));
    this.setState({agents, showAgentsResults: true})
  }


  toggleDescription = () => {
    const collapsed = this.state.isCollapsed;
    this.setState({isCollapsed: !collapsed});
  }

  toggleContactAgent = () => {
    const collapsed = this.state.showContactAgent;
    this.setState({showContactAgent: !collapsed});
  }


  render(){
    const {loading, itinerary, selectedTour, agents, states, cities, agentData, isCollapsed, showContactAgent} = this.state;
    const dates = itinerary.tours.length == 0 ? [] : itinerary.tours.map((tour:any) => {
          return {id: tour.id, date: tour.departure_date, price: `${itinerary.priceCurrency} ${tour.price}`}
        });
    const tourInclusives = thingsToKnow(itinerary.includings);

    return (
      <div id="show-page">

      <Layout style={layoutStyle}>
        
        <>
          <Headline showSearch={false} bannerImage={itinerary.coverImage} breadcrumbs={breadcrumbs}>
            <div id="show-page_header"> 
              <Flex justify="space-between" vertical gap={45}>
                <h1>{selectedTour?.caption}</h1> 
                <div className="tour_details"> 
                  <span className="tour_details_country"> <Icon path={mdiMapMarkerOutline} size="16px" />  {itinerary?.country} </span> 
                  <span className="tour_details_code"> <Icon path={mdiFileDownload} size="16px" />  {selectedTour?.code} </span> 
                </div>
              </Flex>
            </div>
          </Headline>

          <div id="date-selector">
            <Slider {...settings}>
              {
                dates.map((tour, index) => {
                  return <div key={index} className={`date-box ${selectedTour?.id == tour.id && "selected"}`} onClick={()=>this.selectTour(tour.id)}>
                    <Flex justify="space-between" align="center" vertical gap={8}>
                      <div className="date-box_date"> {tour.date} </div>
                      <div>
                        <span>From</span>
                        <div className="date-box_price"> {tour.price} </div>
                      </div>
                    </Flex>
                  </div>
                })
              }
            </Slider>
          </div>
        </>
        
        <Layout id="show-page_body">
          <Content>
            {
              loading ? (
                <Space direction="vertical" style={{width: '100%'}}>
                  <Skeleton/>
                  <Skeleton/>
                  <Skeleton/>
                </Space>
              ) : (
                <div className="details">
                  <Flex gap={10} vertical>
                    {
                      (tourInclusives.every(x => x.visible) || selectedTour?.guaranteed_departure) && (
                        <div className="details-container">
                          <div className="details-container_header"> Tour Inclusive </div>
                          <div className="details-container_content"> 
                            <div id="things-to-know">
                              {
                                tourInclusives.filter(item => item.visible)
                                  .map(item => (
                                    <div className="item">
                                      <div className="icon"> {item.icon} </div>
                                      <label>{item.label}</label>
                                    </div>
                                  ))
                              }
                              {
                                selectedTour?.guaranteed_departure && (
                                  <div className="item guaranteed">
                                    <div className="icon"> <Icon path={mdiShieldAirplane} size={1} /></div>
                                    <label>Guaranteed Departure</label>
                                  </div>
                                )
                              }
                            </div>
                          </div>
                        </div>
                      )
                    }

                    <div className="details-container">
                      <div className="details-container_header"> Description </div>
                      <div className="details-container_content"> 
                        <div id="description" className={`${isCollapsed && 'collapsed'}`}>
                          <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{itinerary?.description}</Markdown>
                        </div>
                        <Button className="toggle-description" color="default" variant="filled" block onClick={this.toggleDescription}>{ isCollapsed ? 'Expand' : 'Collapse'} 
                          <Icon path={isCollapsed ? mdiMenuDown : mdiMenuUp} size="19px" /> 
                        </Button>
                      </div>
                    </div>

                    {
                      selectedTour?.flights.length > 0  && (
                        <div className="details-container">
                          <div className="details-container_header"> Schedule Flight(s) </div>
                          <div className="details-container_content"> 
                            <Flex gap={20} vertical>
                              {
                                selectedTour?.flights.map((flight:any) => (
                                  <div className="schedule" key={flight.id}>
                                    <div className="flight-date"> 
                                      <Icon path={mdiAirplane} size="12px" />
                                      <span>{flight.departure_date}</span>
                                    </div>
                                    <div className="flight-details"> 
                                      <label> {flight.from_airport} &gt; {flight.to_airport} </label>
                                      <div className="flight-details_airline">
                                        <img src={flight.airline_logo} />
                                        <span>{flight.airline}</span>
                                      </div>
                                    </div>
                                    <div className="flight-time"> 
                                      <Flex gap={13}>
                                        <div className="from">
                                          <label>{flight.departure_time}</label>
                                          <span>{flight.from_airport}</span>
                                        </div>
                                        <div className="flight-time_icon">
                                          <img src="/iceholidays-assets/images/plane.png" />
                                        </div>
                                        <div className="to">
                                          <label>{flight.arrival_time}</label>
                                          <span>{flight.to_airport}</span>
                                        </div>
                                      </Flex>
                                    </div>
                                  </div>
                                ))
                              }
                            </Flex>
                          </div>
                        </div>
                      )
                    }

                    {selectedTour?.prices.length > 0 && <PriceDetails priceCurrency={itinerary.priceCurrency} prices={selectedTour?.prices}/>}

                  </Flex>
                </div>
              )
            }
          </Content>
          <Sider width="265px" style={siderStyle} className={`contact-agent-sider ${showContactAgent && 'show-contact-agent-mobile'}`}>
            <div className="toggle_contact-agent" onClick={this.toggleContactAgent}> 
              <span>Contact Agent</span>
            </div>
            <div className="contact-agent">
              <div className="contact-agent_header"> 
                <span>Contact Agent</span>
                <Button className="collapse-contact-agent" color="default" variant="text" 
                  icon={<Icon path={mdiClose} size="19px" />}
                  onClick={this.toggleContactAgent}/>
              </div>
              <div className="contact-agent_content"> 
                <ContactAgentsForm 
                  states={states} 
                  cities={cities} 
                  findAgents={this.findAgents} 
                  filterCities={this.filterCities}
                  filterStates={this.filterStates}/>

                {
                  this.state.showAgentsResults && (
                    <div className="search-results">
                      <Flex vertical gap={20}>
                        {
                          agents.length > 0 && agents.map((agent:Agent) => {
                            return (
                              <Row gutter={2} justify="space-between" className="agent-info">
                                <Col flex="180px"><span className="company" onClick={()=>this.showModal(agent)}>
                                  {agent.name}</span>
                                </Col>
                                <Col flex="none"><Button color="default" variant="filled" shape="circle" size="small" icon={<Icon path={mdiPhoneInTalkOutline} size="16px" />}/></Col>
                                <Col flex="none"><Button color="default" variant="filled" shape="circle" size="small" icon={<Icon path={mdiEmailOutline} size="16px" />}/></Col>
                                <Col>
                                  <div className="contact-numbers">
                                    <Button size="small" color="primary" variant="outlined">
                                      <Icon path={mdiWhatsapp} size="12px" />
                                      {agent.whatsapp}
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            )
                          })
                        }
                      </Flex>
                    </div>
                  )
                }
              </div>
            </div>
          </Sider>
        </Layout>
      </Layout>


      <Modal title={<img src={agentData?.image}/>} open={this.state.setIsModalOpen} onCancel={()=>this.closeModal()} footer={null} width={325} centered className="agent-full-contact-details">
        <h2> {agentData?.name} </h2>
        <div className="contact-details">
          <Row gutter={[15, 15]} align="middle">
            <Col span={24}>
              <Icon path={mdiMapMarker} size="15px" />
              <span>{agentData?.address}</span>
            </Col>
          {/* </Row>
          <Row gutter={15} align="middle"> */}
            <Col xs={24} sm={24} lg={6}>
              <Icon path={mdiPhoneInTalkOutline} size="15px" />
              <span>{agentData?.phone}</span>
            </Col>
            <Col xs={24} sm={24} lg={6}>
              <Icon path={mdiWhatsapp} size="15px" />
              <span>{agentData?.whatsapp}</span>
            </Col>
            <Col xs={24} sm={24} lg={9}>
              <Icon path={mdiEmailOutline} size="15px" />
              <span>{agentData?.email}</span>
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
    )
  }

}

export default withParams(ShowPage);